import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { EMPTY_LIST } from '../../../../../../../../../constants/common'
import { useDebounce } from '../../../../../../../../../hooks'
import { postMockListingMatchRulesPreview } from '../../../../../../../../RentalPortalListing'
import { MATCH_RULES_PREVIEW_DELAY } from '../../../ListingProfileApplicantsMatchRules.constants'

export function useMatchRulesImpactPreview({ criteria, rules }) {
  const { t } = useTranslation()

  const [distribution, setDistribution] = useState(rules.current_distribution)

  const debouncedCriteria = useDebounce(
    criteria.join(),
    MATCH_RULES_PREVIEW_DELAY
  )

  useEffect(() => {
    let isCurrent = true

    postMockListingMatchRulesPreview({
      criteria: debouncedCriteria ? debouncedCriteria.split(',') : EMPTY_LIST,
    }).then(next => {
      if (isCurrent) {
        setDistribution(next)
      }
    })

    return () => {
      isCurrent = false
    }
  }, [debouncedCriteria])

  return {
    impact: t('RentalPortal.MatchRulesImpactKey', {
      eligible: distribution.eligible,
      incomplete: distribution.incomplete,
      notEligible: distribution.not_eligible,
      total: rules.affected_applicants_count,
    }),
  }
}
